/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Observable } from 'rxjs';

//set of inputs for the simple popup
export interface SimplePopupInputs {
	headingText?: string;
	descriptionText?: string;
	customSaveText?: string;
	customCancelText?: string;
}

export enum PopupOutputType {
	canceled = 'canceled',
	update = 'update',
}
//observable output
export interface PopupOutput {
	type: PopupOutputType;
	data?: object;
}

//how the popup compatible component communicates with the service
// to be implemented by the PopupComponents
export interface PopupCommunication {
	popupInit: (data: any) => void;
	output$: Observable<PopupOutput>;
}
